/* eslint-disable prefer-const */
/* eslint-disable guard-for-in */
/* eslint-disable no-unreachable */
/* eslint-disable no-unreachable-loop */
/* eslint-disable no-console */
/* eslint-disable max-len */
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setUploadFile } from '../../../redux/MediakitRedux';
import { catchErr, fileToObjectUrl } from '../../../libs/HelperContent';
import useCheckExistFolder from './useCheckExistFolder';
import { useContext } from 'react';
import { LanguageContext } from '../../../libs/Context';
import useUpdateStorage from '../../LicenseSubscription/customHooks/useGetStorage';
import heic2any from 'heic2any';

const useUploadFiles = (pauseFunction, clickedData, setMediaState, setProgress) =>
{
	let { tab, id = '' } = useParams();
	const urlPath = new URL(window.location.href).pathname;
	const isEditingTemplate = urlPath.match('drive/edit');
	const checkFolderName = useCheckExistFolder();
	const dispatch = useDispatch();
	const openedTab = tab === 'folder' || isEditingTemplate ? 'folderData' : tab === 'shared' ? 'sharedData' : '';
	const uploadFile = useSelector((state:any) => state.mymediakit.uploadFile);
	const { language } = useContext(LanguageContext);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const ownerCompanyId = tab === 'shared' ? clickedData?.companyId : userData?.companyId;
	const setStorageData = useUpdateStorage();

	const uploadFilesFunc = async (files, parentId = '') =>
	{
		setProgress(true);
		id = parentId || id;
		setMediaState({ type: 'setMenuItems', payload: { create: 0 } });

		let currentUploadsInfo: any = [];

		if (!files || files.length > 10)
		{
			toast.error(language?.cannot10Files, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
			setProgress(false);

			return;
		}

		const convertedFiles = await Promise.all(files.map(async (file) =>
		{
			let fileToUpload = file;

			if (
				file?.type === 'image/heic' || file?.type === 'image/heif' ||
					file?.type === 'image/webp' || file?.type === 'application/octet-stream' ||
					file?.name?.toLowerCase()?.endsWith('.heic') ||
					file?.name?.toLowerCase()?.endsWith('.heif') ||
					file?.name?.toLowerCase()?.endsWith('.webp')
			)
			{
				try
				{
					let convertedBlob;

					if (file?.type === 'image/webp' || file?.name?.toLowerCase()?.endsWith('.webp'))
					{
						const newName = file.name.replace(/\.[^/.]+$/, '.jpg');

						convertedBlob = new File([ file ], newName, { type: 'image/jpeg' });
					}
					else
					{
						convertedBlob = await heic2any({ blob: file, toType: 'image/jpeg' });
						const newName = file.name.replace(/\.[^/.]+$/, '.jpg');

						convertedBlob = new File([ convertedBlob ], newName, { type: 'image/jpeg' });
					}

					fileToUpload = convertedBlob;
				}
				catch (err)
				{
					console.error('Conversion failed for:', file?.name, err);

					return null;
				}
			}

			// if (fileToUpload.size > 20 * 1024 * 1024)
			// {
			// 	toast.error(`${fileToUpload?.name} is too large. Max size is 20MB.`, {
			// 		position  : toast.POSITION.TOP_RIGHT,
			// 		className : 'toast-message'
			// 	});

			// 	return null;
			// }

			const objectUrl = await fileToObjectUrl(fileToUpload);

			return {
				objectUrl,
				name       : fileToUpload.name,
				type       : fileToUpload.type,
				size       : fileToUpload.size,
				openedTab,
				parentId   : id,
				ownerCompanyId,
				parentData : clickedData
			};
		}));

		const validFiles = convertedFiles.filter(Boolean);
		const nameArr = validFiles.map((file) => file.name);

		currentUploadsInfo = [ ...validFiles ];

		try
		{
			const checkExist = await checkFolderName(nameArr, id, 1);

			if (checkExist?.data?.length > 0)
			{
				const replace = await pauseFunction();

				if (replace?.replace === 'cancel')
				{
					const size:number = files.reduce((total:number, item:any) => total + item?.size, 0);

					setStorageData({ action: 'del', size, ownerCompanyId });

					return;
				}
				else if (replace?.replace === 'yes')
				{
					currentUploadsInfo = currentUploadsInfo.map((uplData) =>
					{
						const foundFile = checkExist.data.find((prevData) => prevData.name?.toLowerCase() === uplData.name?.toLowerCase());

						return foundFile ? { ...uplData, ...foundFile, updateExist: true } : uplData;
					});
				}
				else
				{
					currentUploadsInfo = currentUploadsInfo.map((uplData) =>
					{
						const foundFile = checkExist.data.find((prevData) => prevData.name?.toLowerCase() === uplData.name?.toLowerCase());

						if (!foundFile) return uplData;

						const nameArray = uplData.name.split('.');
						const ext = nameArray.length > 1 ? `.${nameArray.pop()}` : '';
						const newName = nameArray.join('.').concat('_', new Date().valueOf(), ext);

						return { ...uplData, name: newName };
					});
				}
			}

			dispatch(setUploadFile([ ...uploadFile, ...currentUploadsInfo ]));
			setTimeout(() => setProgress(false), 500);
		}
		catch (err)
		{
			catchErr(err);
		}
		finally
		{
			setTimeout(() => setProgress(false), 500);
		}
	};

	return { uploadFilesFunc };
};

export default useUploadFiles;